exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.address_block tr:first-child td[data-v-ee351ec4] {\n  border-top: none;\n}\ntable.address_block td[data-v-ee351ec4] {\n  padding-left: 0px !important;\n}\n.action_icon[data-v-ee351ec4] {\n  color: #5A4587 !important;\n}\n.action_icon[data-v-ee351ec4]:hover {\n  color: #9b89c3 !important;\n}\n", ""]);

// exports
